import axios from 'axios'

export const uploadToPresignedUrl = (data: {
	presignedS3Url: string
	file: Blob
	/** Called with 0-100 as the upload progresses. */
	onProgress?: (percent: number) => void
}) => {
	const { type } = data.file
	const { onProgress } = data
	return axios.put(data.presignedS3Url, data.file, {
		headers: { 'Content-Type': type },
		onUploadProgress: onProgress
			? event => {
					if (event.total) onProgress(Math.round((event.loaded / event.total) * 100))
				}
			: undefined,
	})
}

export async function uploadClubImage(url: string, file: File) {
	try {
		const response = await fetch(url, {
			method: 'PUT',
			body: file, // Send the file directly as the request body
		})

		if (response.ok) {
			console.log('File uploaded successfully!')
			return true
		} else {
			console.error('File upload failed.')
			return false
		}
	} catch (err) {
		console.log('ERROR UPLOADING CLUB IMAGE', err)
		return false
	}
}
